<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div class="toc-contents">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">1. </span><a href="#/chapter001"><span class="element-title-text">A partridge in a pear tree</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">2. </span><span href="#/chapter002" title="Link target outside of Sample"><span class="element-title-text">Two turtle doves</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="element-title-text">Three French hens</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="element-title-text">Four calling birds</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="element-title-text">Five golden rings</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="element-title-text">Six geese a-laying</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="element-title-text">Seven swans a-swimming</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">8. </span><span href="#/chapter008" title="Link target outside of Sample"><span class="element-title-text">Eight maids a-milking</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">9. </span><span href="#/chapter009" title="Link target outside of Sample"><span class="element-title-text">Nine ladies dancing</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">10. </span><span href="#/chapter010" title="Link target outside of Sample"><span class="element-title-text">Ten lords a-leaping</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">11. </span><span href="#/chapter011" title="Link target outside of Sample"><span class="element-title-text">Eleven pipers piping</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">12. </span><span href="#/chapter012" title="Link target outside of Sample"><span class="element-title-text">Twelve drummers drumming</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-epilogue has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/epilogue" title="Link target outside of Sample"><span class="element-title-text">Epilogue</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/acknowledgements" title="Link target outside of Sample"><span class="element-title-text">Acknowledgements</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/anotefromthepublisher" title="Link target outside of Sample"><span class="element-title-text">A note from the publisher</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/lovecrimethrillerandmysterybooks" title="Link target outside of Sample"><span class="element-title-text">Love crime, thriller and mystery books?</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/youwillalsoenjoy" title="Link target outside of Sample"><span class="element-title-text">You will also enjoy:</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2bce8259